import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const FavoriteCard = ({ favorite, onRemove, onViewDetails }) => {
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-all duration-250 group">
      <div className="relative h-48 md:h-56 overflow-hidden">
        <Image
          src={favorite?.image}
          alt={favorite?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <button
          onClick={() => onRemove(favorite?.id)}
          className="absolute top-3 right-3 w-10 h-10 bg-background/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-error hover:text-error-foreground transition-all duration-250"
          aria-label="Remove from favorites"
        >
          <Icon name="Heart" size={20} fill="currentColor" />
        </button>
        {favorite?.badge && (
          <div className="absolute top-3 left-3 px-3 py-1 bg-accent text-accent-foreground text-xs font-semibold rounded-full">
            {favorite?.badge}
          </div>
        )}
      </div>
      <div className="p-4 md:p-5">
        <div className="mb-3">
          <h3 className="text-lg md:text-xl font-bold text-foreground mb-1 line-clamp-1">
            {favorite?.name}
          </h3>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="MapPin" size={14} />
            <span className="line-clamp-1">{favorite?.location}</span>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {favorite?.description}
        </p>

        <div className="flex items-center justify-between mb-4 pb-4 border-b border-border">
          <div className="flex items-center gap-1">
            <Icon name="Star" size={16} fill="var(--color-accent)" color="var(--color-accent)" />
            <span className="text-sm font-semibold text-foreground">{favorite?.rating}</span>
            <span className="text-xs text-muted-foreground">({favorite?.reviews})</span>
          </div>
          {favorite?.priceRange && (
            <div className="text-sm font-semibold text-primary">
              ₱{favorite?.priceRange}
            </div>
          )}
        </div>

        <div className="flex gap-2">
          <Button
            variant="default"
            size="sm"
            fullWidth
            onClick={() => onViewDetails(favorite?.id)}
            iconName="Eye"
            iconPosition="left"
          >
            View Details
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Share2"
          />
        </div>
      </div>
    </div>
  );
};

export default FavoriteCard;